export default "__VITE_ASSET__jqr_rWN6__"